import { track } from '@vercel/analytics/react';
import { getAnalyticsConsent } from '../utils/analyticsConsent';
import type { AnalyticsEnvelope, ProductEventName } from './contract';
import { isAnalyticsCollectionAllowed } from './routePrivacy';

export interface ProductAnalyticsTransport {
  send: (name: ProductEventName, properties: AnalyticsEnvelope) => void;
}

export const browserProductAnalyticsTransport: ProductAnalyticsTransport = {
  send(name, properties) {
    if (typeof window === 'undefined') return;
    if (!isAnalyticsCollectionAllowed(
      getAnalyticsConsent(),
      window.location.hostname,
      process.env.NODE_ENV === 'production',
      window.location.pathname,
    )) return;

    track(name, properties);
  },
};
